<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <b-link class="brand-logo">
        <logo />
        <h2 class="brand-text text-primary ml-1">{{ appName }}</h2>
      </b-link>

      <b-navbar-nav class="nav align-items-center ml-auto absolute-locale">
        <locale></locale>
      </b-navbar-nav>

      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5">
        <div
          class="w-100 d-lg-flex align-items-center justify-content-center px-5"
        >
          <b-img fluid :src="imgUrl" alt="Forgot password V2" />
        </div>
      </b-col>

      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <b-card-title title-tag="h2" class="font-weight-bold mb-1">
            {{ $t("forgotPassword.title") }} 🔒
          </b-card-title>
          <b-card-text class="mb-2" v-if="!isSendEmail">
            {{ $t("forgotPassword.subTitle") }}
          </b-card-text>

          <b-card-text class="mb-2" v-else>
            {{ $t("forgotPassword.emailSent") }}
          </b-card-text>

          <validation-observer
            ref="forgotPasswordForm"
            #default="{ invalid }"
            v-if="!isSendEmail"
          >
            <b-form
              class="auth-forgot-password-form mt-2"
              @submit.prevent="validationForm"
            >
              <n-input :fields="fields" v-model="data"> </n-input>

              <n-button-loading
                type="submit"
                variant="primary"
                :loading="loading"
                :disabled="invalid"
                block
              >
                {{ $t("button.sendResetLink") }}
              </n-button-loading>
            </b-form>
          </validation-observer>

          <b-card-text class="mb-2" v-else>
            {{ $t("forgotPassword.doNotRecieveEmail") }}
            <b-spinner variant="primary" small v-if="loading"></b-spinner>
            <span v-if="!loading && isHideResentOtp">{{ countDown }}</span>
            <b-link
              v-if="!loading && !isHideResentOtp"
              class="link-underline"
              @click="submit"
              >{{ $t("button.resend") }}</b-link
            >
          </b-card-text>

          <p class="text-center mt-2">
            <b-link :to="{ name: 'login' }">
              <feather-icon icon="ChevronLeftIcon" />
              {{ $t("general.backToLogin") }}
            </b-link>
          </p>
        </b-col>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import Logo from "@core/layouts/components/Logo.vue";
import {
  BRow,
  BCol,
  BLink,
  BCardTitle,
  BCardText,
  BImg,
  BForm,
  BButton,
  BNavbarNav,
  BSpinner,
} from "bootstrap-vue";
import store from "@/store/index";
import { $themeConfig } from "@themeConfig";
import FormInput from "./forgotPasswordFormInput";
import NInput from "@/components/NInput";
import NButtonLoading from "@/components/NButtonLoading";
import Locale from "@/layouts/components/app-navbar/Locale.vue";
import Repository from "@/repositories/RepositoryFactory";

const ForgotPasswordRepository = Repository.get("forgotPassword");

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BImg,
    BForm,
    BButton,
    BCardTitle,
    BCardText,
    BNavbarNav,
    BSpinner,
    Logo,
    Locale,
    NInput,
    NButtonLoading,
  },
  data() {
    return {
      data: {
        email: null,
      },
      loading: false,
      isSendEmail: false,
      countDown: 60,
      isHideResentOtp: false,
      sideImg: require("@/assets/images/pages/forgot-password-v2.svg"),
    };
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === "dark") {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require("@/assets/images/pages/forgot-password-v2-dark.svg");
        return this.sideImg;
      }
      return this.sideImg;
    },
  },
  methods: {
    validationForm() {
      this.$refs.forgotPasswordForm.validate().then((success) => {
        if (success) {
          this.submit();
        }
      });
    },
    submit() {
      this.loading = true;

      ForgotPasswordRepository.forgotPassword({ ...this.data })
        .then((response) => {
          const data = response?.data?.data;

          if (data.isEmailExist) {
            this.isSendEmail = true;
            this.hideResentOtp();
          } else {
            this.$refs.forgotPasswordForm.setErrors({
              email: this.$t("validations.messages.exists", {
                _field_: this.$t("field.email"),
              }),
            });
          }
        })
        .catch((error) => {})
        .then(() => {
          this.loading = false;
        });
    },
    hideResentOtp() {
      this.isHideResentOtp = true;
      let self = this;
      let interval = setInterval(function () {
        if (self.countDown <= 0) {
          clearInterval(interval);
          self.isHideResentOtp = false;
          self.countDown = 60;
        }

        self.countDown = self.countDown - 1;
      }, 1000);
    },
  },
  setup() {
    const { appName } = $themeConfig.app;
    const fields = FormInput;

    return {
      appName,
      fields,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
